// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login Page - Light theme matching site design */

.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: var(--bg-primary, #f8f9fa);
}

/* Animated Background - same as main site */
.login-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.login-bg-gradient {
  position: absolute;
  inset: 0;
  opacity: 0.05;
  background:
    radial-gradient(circle at 20% 30%, var(--accent-orange, #FF6B4A) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, var(--accent-purple, #8E3A9A) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, var(--accent-red, #E94B6C) 0%, transparent 60%);
  animation: gradientShift 20s ease infinite;
}

@keyframes gradientShift {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(50px, 30px) scale(1.1); }
}

.login-bg-noise {
  display: none;
}

.login-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.08;
  animation: floatOrb 20s ease-in-out infinite;
}

.login-orb-1 {
  width: 300px;
  height: 300px;
  background: var(--accent-orange, #FF6B4A);
  top: 10%;
  left: 5%;
  animation-delay: 0s;
}

.login-orb-2 {
  width: 400px;
  height: 400px;
  background: var(--accent-purple, #8E3A9A);
  bottom: 10%;
  right: 10%;
  animation-delay: 5s;
}

.login-orb-3 {
  width: 250px;
  height: 250px;
  background: var(--accent-red, #E94B6C);
  top: 50%;
  right: 20%;
  animation-delay: 10s;
}

@keyframes floatOrb {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(50px, -30px) scale(1.1); }
  66% { transform: translate(-30px, 50px) scale(0.9); }
}

/* Main Container */
.login-container {
  display: flex;
  width: 100%;
  max-width: 1100px;
  min-height: 600px;
  margin: 24px;
  position: relative;
  z-index: 1;
  background: var(--bg-secondary, #ffffff);
  border-radius: 20px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  overflow: hidden;
  box-shadow: 0 20px 60px -20px rgba(0, 0, 0, 0.15);
}

/* Branding Side */
.login-branding {
  flex: 1 1;
  padding: 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.06) 0%, rgba(142, 58, 154, 0.06) 100%);
  border-right: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
}

.login-branding::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, #FF6B4A, #E94B6C, #8E3A9A);
}

.login-branding-content {
  animation: fadeInUp 0.8s ease;
}

.login-logo {
  height: 40px;
  width: auto;
  margin-bottom: 40px;
  filter: drop-shadow(0 4px 12px rgba(255, 107, 74, 0.25));
}

.login-tagline {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.15;
  color: var(--text-primary, #1a1a1a);
  letter-spacing: -0.5px;
  margin-bottom: 20px;
}

.login-tagline span {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.login-description {
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-secondary, #6c757d);
  max-width: 360px;
}

.login-branding-footer {
  display: flex;
  gap: 28px;
  animation: fadeInUp 0.8s ease 0.2s both;
}

.login-feature {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary, #6c757d);
  font-size: 13px;
  font-weight: 500;
}

.login-feature svg {
  width: 18px;
  height: 18px;
  stroke: var(--accent-orange, #FF6B4A);
}

/* Form Side */
.login-form-container {
  flex: 1 1;
  padding: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--bg-secondary, #ffffff);
}

.login-form-card {
  width: 100%;
  max-width: 360px;
  animation: fadeInUp 0.6s ease;
}

.login-form-header {
  margin-bottom: 28px;
  text-align: center;
}

.login-form-header h2 {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary, #1a1a1a);
  margin-bottom: 6px;
}

.login-form-header p {
  font-size: 14px;
  color: var(--text-secondary, #6c757d);
}

/* Error Message */
.login-error {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: rgba(231, 76, 60, 0.08);
  border: 1px solid rgba(231, 76, 60, 0.15);
  border-radius: 10px;
  margin-bottom: 20px;
  animation: shake 0.5s ease;
}

.login-error svg {
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  stroke: #e74c3c;
  flex-shrink: 0;
}

.login-error span {
  font-size: 13px;
  color: #c0392b;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Success notice (e.g. after email verification) */
.login-notice {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: rgba(39, 174, 96, 0.08);
  border: 1px solid rgba(39, 174, 96, 0.18);
  border-radius: 10px;
  margin-bottom: 20px;
}
.login-notice svg {
  width: 18px;
  height: 18px;
  min-width: 18px;
  stroke: #27ae60;
  flex-shrink: 0;
}
.login-notice span {
  font-size: 13px;
  color: #1e8449;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-8px); }
  40% { transform: translateX(8px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
}

/* Form Fields */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.login-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.login-field label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary, #6c757d);
}

.login-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.login-input-wrapper svg {
  position: absolute;
  left: 14px;
  width: 18px;
  height: 18px;
  stroke: var(--text-tertiary, #adb5bd);
  transition: stroke 0.2s ease;
  pointer-events: none;
}

.login-input-wrapper input {
  width: 100%;
  padding: 14px 14px 14px 46px;
  font-size: 14px;
  color: var(--text-primary, #1a1a1a);
  background: var(--bg-primary, #f8f9fa);
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  border-radius: 10px;
  outline: none;
  transition: all 0.2s ease;
}

.login-input-wrapper input::placeholder {
  color: var(--text-tertiary, #adb5bd);
}

.login-input-wrapper input:focus {
  background: var(--bg-secondary, #ffffff);
  border-color: var(--accent-orange, #FF6B4A);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.login-input-wrapper:focus-within svg {
  stroke: var(--accent-orange, #FF6B4A);
}

/* Password toggle */
.login-password-toggle {
  position: absolute;
  right: 10px;
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.login-password-toggle:hover {
  opacity: 0.8;
}

.login-password-toggle svg {
  position: static;
  width: 18px;
  height: 18px;
  stroke: var(--text-secondary, #6c757d);
}

/* TOTP Input */
.login-input-totp input {
  font-family: 'SF Mono', 'Monaco', monospace;
  font-size: 22px;
  letter-spacing: 6px;
  text-align: center;
  padding-left: 46px;
  padding-right: 14px;
}

.login-back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 0;
  background: none;
  border: none;
  color: var(--text-secondary, #6c757d);
  font-size: 13px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.login-back-link:hover {
  color: var(--accent-orange, #FF6B4A);
}

.login-back-link svg {
  width: 16px;
  height: 16px;
}

/* Checkbox */
.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.login-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 13px;
  color: var(--text-secondary, #6c757d);
  -webkit-user-select: none;
          user-select: none;
}

.login-checkbox input {
  display: none;
}

.login-checkbox-mark {
  width: 18px;
  height: 18px;
  border: 2px solid var(--border-color, rgba(0, 0, 0, 0.15));
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  background: var(--bg-secondary, #ffffff);
}

.login-checkbox-mark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) scale(0);
  transition: transform 0.2s ease;
}

.login-checkbox input:checked + .login-checkbox-mark {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);
  border-color: transparent;
}

.login-checkbox input:checked + .login-checkbox-mark::after {
  transform: rotate(45deg) scale(1);
}

/* Submit Button */
.login-submit {
  width: 100%;
  padding: 16px;
  margin-top: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
  background-size: 200% 200%;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.login-submit::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.login-submit:hover:not(:disabled) {
  background-position: 100% 100%;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px -8px rgba(255, 107, 74, 0.5);
}

.login-submit:hover:not(:disabled)::before {
  opacity: 1;
}

.login-submit:active:not(:disabled) {
  transform: translateY(0);
}

.login-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-submit-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Loading State */
.login-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--bg-primary, #f8f9fa);
}

.login-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-color, rgba(0, 0, 0, 0.08));
  border-top-color: var(--accent-orange, #FF6B4A);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Footer */
.login-footer-text {
  margin-top: 28px;
  font-size: 12px;
  color: var(--text-tertiary, #adb5bd);
  text-align: center;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 900px) {
  .login-container {
    flex-direction: column;
    max-width: 440px;
    min-height: auto;
  }

  .login-branding {
    padding: 32px;
    border-right: none;
    border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  }

  .login-branding::before {
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #FF6B4A, #E94B6C, #8E3A9A);
  }

  .login-tagline {
    font-size: 28px;
  }

  .login-branding-footer {
    display: none;
  }

  .login-form-container {
    padding: 32px;
  }
}

@media (max-width: 480px) {
  .login-container {
    margin: 0;
    border-radius: 0;
    min-height: 100vh;
    border: none;
    box-shadow: none;
  }

  .login-branding {
    padding: 24px;
  }

  .login-form-container {
    padding: 24px;
  }

  .login-tagline {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb;;;sFAGoF;EACpF,0CAA0C;AAC5C;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,QAAQ;EACR,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,MAAM,4CAA4C,EAAE;EACpD,MAAM,4CAA4C,EAAE;AACtD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,wCAAwC;EACxC,mBAAmB;EACnB,0DAA0D;EAC1D,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,+FAA+F;EAC/F,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,8DAA8D;AAChE;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,qEAAqE;EACrE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qEAAqE;EACrE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,mCAAmC;EACnC,sCAAsC;EACtC,0DAA0D;EAC1D,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,qCAAqC;EACrC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0EAA0E;EAC1E,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8EAA8E;EAC9E,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,+CAA+C;EAC/C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,iEAAiE;EACnE;;EAEA;IACE,WAAW;IACX,WAAW;IACX,6DAA6D;EAC/D;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Login Page - Light theme matching site design */\n\n.login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  background: var(--bg-primary, #f8f9fa);\n}\n\n/* Animated Background - same as main site */\n.login-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.login-bg-gradient {\n  position: absolute;\n  inset: 0;\n  opacity: 0.05;\n  background:\n    radial-gradient(circle at 20% 30%, var(--accent-orange, #FF6B4A) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, var(--accent-purple, #8E3A9A) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, var(--accent-red, #E94B6C) 0%, transparent 60%);\n  animation: gradientShift 20s ease infinite;\n}\n\n@keyframes gradientShift {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50% { transform: translate(50px, 30px) scale(1.1); }\n}\n\n.login-bg-noise {\n  display: none;\n}\n\n.login-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(60px);\n  opacity: 0.08;\n  animation: floatOrb 20s ease-in-out infinite;\n}\n\n.login-orb-1 {\n  width: 300px;\n  height: 300px;\n  background: var(--accent-orange, #FF6B4A);\n  top: 10%;\n  left: 5%;\n  animation-delay: 0s;\n}\n\n.login-orb-2 {\n  width: 400px;\n  height: 400px;\n  background: var(--accent-purple, #8E3A9A);\n  bottom: 10%;\n  right: 10%;\n  animation-delay: 5s;\n}\n\n.login-orb-3 {\n  width: 250px;\n  height: 250px;\n  background: var(--accent-red, #E94B6C);\n  top: 50%;\n  right: 20%;\n  animation-delay: 10s;\n}\n\n@keyframes floatOrb {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  33% { transform: translate(50px, -30px) scale(1.1); }\n  66% { transform: translate(-30px, 50px) scale(0.9); }\n}\n\n/* Main Container */\n.login-container {\n  display: flex;\n  width: 100%;\n  max-width: 1100px;\n  min-height: 600px;\n  margin: 24px;\n  position: relative;\n  z-index: 1;\n  background: var(--bg-secondary, #ffffff);\n  border-radius: 20px;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  overflow: hidden;\n  box-shadow: 0 20px 60px -20px rgba(0, 0, 0, 0.15);\n}\n\n/* Branding Side */\n.login-branding {\n  flex: 1;\n  padding: 48px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.06) 0%, rgba(142, 58, 154, 0.06) 100%);\n  border-right: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n}\n\n.login-branding::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 3px;\n  height: 100%;\n  background: linear-gradient(180deg, #FF6B4A, #E94B6C, #8E3A9A);\n}\n\n.login-branding-content {\n  animation: fadeInUp 0.8s ease;\n}\n\n.login-logo {\n  height: 40px;\n  width: auto;\n  margin-bottom: 40px;\n  filter: drop-shadow(0 4px 12px rgba(255, 107, 74, 0.25));\n}\n\n.login-tagline {\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1.15;\n  color: var(--text-primary, #1a1a1a);\n  letter-spacing: -0.5px;\n  margin-bottom: 20px;\n}\n\n.login-tagline span {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.login-description {\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--text-secondary, #6c757d);\n  max-width: 360px;\n}\n\n.login-branding-footer {\n  display: flex;\n  gap: 28px;\n  animation: fadeInUp 0.8s ease 0.2s both;\n}\n\n.login-feature {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-secondary, #6c757d);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.login-feature svg {\n  width: 18px;\n  height: 18px;\n  stroke: var(--accent-orange, #FF6B4A);\n}\n\n/* Form Side */\n.login-form-container {\n  flex: 1;\n  padding: 48px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: var(--bg-secondary, #ffffff);\n}\n\n.login-form-card {\n  width: 100%;\n  max-width: 360px;\n  animation: fadeInUp 0.6s ease;\n}\n\n.login-form-header {\n  margin-bottom: 28px;\n  text-align: center;\n}\n\n.login-form-header h2 {\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary, #1a1a1a);\n  margin-bottom: 6px;\n}\n\n.login-form-header p {\n  font-size: 14px;\n  color: var(--text-secondary, #6c757d);\n}\n\n/* Error Message */\n.login-error {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: rgba(231, 76, 60, 0.08);\n  border: 1px solid rgba(231, 76, 60, 0.15);\n  border-radius: 10px;\n  margin-bottom: 20px;\n  animation: shake 0.5s ease;\n}\n\n.login-error svg {\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n  min-height: 18px;\n  stroke: #e74c3c;\n  flex-shrink: 0;\n}\n\n.login-error span {\n  font-size: 13px;\n  color: #c0392b;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n/* Success notice (e.g. after email verification) */\n.login-notice {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: rgba(39, 174, 96, 0.08);\n  border: 1px solid rgba(39, 174, 96, 0.18);\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n.login-notice svg {\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n  stroke: #27ae60;\n  flex-shrink: 0;\n}\n.login-notice span {\n  font-size: 13px;\n  color: #1e8449;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  20% { transform: translateX(-8px); }\n  40% { transform: translateX(8px); }\n  60% { transform: translateX(-4px); }\n  80% { transform: translateX(4px); }\n}\n\n/* Form Fields */\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.login-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.login-field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary, #6c757d);\n}\n\n.login-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.login-input-wrapper svg {\n  position: absolute;\n  left: 14px;\n  width: 18px;\n  height: 18px;\n  stroke: var(--text-tertiary, #adb5bd);\n  transition: stroke 0.2s ease;\n  pointer-events: none;\n}\n\n.login-input-wrapper input {\n  width: 100%;\n  padding: 14px 14px 14px 46px;\n  font-size: 14px;\n  color: var(--text-primary, #1a1a1a);\n  background: var(--bg-primary, #f8f9fa);\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  border-radius: 10px;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.login-input-wrapper input::placeholder {\n  color: var(--text-tertiary, #adb5bd);\n}\n\n.login-input-wrapper input:focus {\n  background: var(--bg-secondary, #ffffff);\n  border-color: var(--accent-orange, #FF6B4A);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.login-input-wrapper:focus-within svg {\n  stroke: var(--accent-orange, #FF6B4A);\n}\n\n/* Password toggle */\n.login-password-toggle {\n  position: absolute;\n  right: 10px;\n  padding: 8px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  opacity: 0.5;\n  transition: opacity 0.2s ease;\n}\n\n.login-password-toggle:hover {\n  opacity: 0.8;\n}\n\n.login-password-toggle svg {\n  position: static;\n  width: 18px;\n  height: 18px;\n  stroke: var(--text-secondary, #6c757d);\n}\n\n/* TOTP Input */\n.login-input-totp input {\n  font-family: 'SF Mono', 'Monaco', monospace;\n  font-size: 22px;\n  letter-spacing: 6px;\n  text-align: center;\n  padding-left: 46px;\n  padding-right: 14px;\n}\n\n.login-back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n  padding: 0;\n  background: none;\n  border: none;\n  color: var(--text-secondary, #6c757d);\n  font-size: 13px;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.login-back-link:hover {\n  color: var(--accent-orange, #FF6B4A);\n}\n\n.login-back-link svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Checkbox */\n.login-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.login-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--text-secondary, #6c757d);\n  user-select: none;\n}\n\n.login-checkbox input {\n  display: none;\n}\n\n.login-checkbox-mark {\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--border-color, rgba(0, 0, 0, 0.15));\n  border-radius: 4px;\n  position: relative;\n  transition: all 0.2s ease;\n  background: var(--bg-secondary, #ffffff);\n}\n\n.login-checkbox-mark::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 5px;\n  width: 5px;\n  height: 9px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg) scale(0);\n  transition: transform 0.2s ease;\n}\n\n.login-checkbox input:checked + .login-checkbox-mark {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);\n  border-color: transparent;\n}\n\n.login-checkbox input:checked + .login-checkbox-mark::after {\n  transform: rotate(45deg) scale(1);\n}\n\n/* Submit Button */\n.login-submit {\n  width: 100%;\n  padding: 16px;\n  margin-top: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n  background-size: 200% 200%;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-submit::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 50%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.login-submit:hover:not(:disabled) {\n  background-position: 100% 100%;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px -8px rgba(255, 107, 74, 0.5);\n}\n\n.login-submit:hover:not(:disabled)::before {\n  opacity: 1;\n}\n\n.login-submit:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-submit:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.login-submit-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Loading State */\n.login-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: var(--bg-primary, #f8f9fa);\n}\n\n.login-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  border-top-color: var(--accent-orange, #FF6B4A);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Footer */\n.login-footer-text {\n  margin-top: 28px;\n  font-size: 12px;\n  color: var(--text-tertiary, #adb5bd);\n  text-align: center;\n}\n\n/* Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .login-container {\n    flex-direction: column;\n    max-width: 440px;\n    min-height: auto;\n  }\n\n  .login-branding {\n    padding: 32px;\n    border-right: none;\n    border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  }\n\n  .login-branding::before {\n    width: 100%;\n    height: 3px;\n    background: linear-gradient(90deg, #FF6B4A, #E94B6C, #8E3A9A);\n  }\n\n  .login-tagline {\n    font-size: 28px;\n  }\n\n  .login-branding-footer {\n    display: none;\n  }\n\n  .login-form-container {\n    padding: 32px;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-container {\n    margin: 0;\n    border-radius: 0;\n    min-height: 100vh;\n    border: none;\n    box-shadow: none;\n  }\n\n  .login-branding {\n    padding: 24px;\n  }\n\n  .login-form-container {\n    padding: 24px;\n  }\n\n  .login-tagline {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
